<clr-dg-filter
    *ngIf="options.length"
    [clrDgFilter]="clrDgFilter"
    avi-tooltip
    [showOnClick]="true"
    [tooltipControl$]="optionsControl$"
    [positionsPriority]="optionsPositionsPriority"
    (onBackdropClick)="closeOptions()"
    (click)="handleClick($event)"
>
    <ng-template #aviTooltipContent>
        <div class="avi-data-grid-dropdown-filter__options clr-wrapper">
            <div
                *ngFor="let option of options; trackBy: trackByValue"
                (click)="handleSelect(option)"
                class="avi-data-grid-dropdown-filter__option"
                [ngClass]="{ 'avi-data-grid-dropdown-filter__option--selected': filter === option.value }"
            >
                {{ option.label }}
            </div>
        </div>
    </ng-template>
</clr-dg-filter>
